import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { connect } from 'react-redux';
import Box from "@mui/material/Box";

import Error from '../Error';
import Header from '../Header';
// import Sidebar from '../Sidebar';
// import StartSurvey from "../survey/StartSurvey";
import { fetchProducts } from "../../actions/productActions";
// import { useNavigate } from 'react-router-dom';

const drawerWidth = 0;

const PrivateRoute = ({ isSignedIn, startSurvey, isRefreshing, noProducts, fetchProducts }) => {
    // const location = useLocation();
    // const navigate = useNavigate();

    // Fetch products when signed in and no products are present
    useEffect(() => {
        if (isSignedIn && noProducts) {
            fetchProducts(); // Call the action to fetch products
        }
    }, [isSignedIn, noProducts, fetchProducts]);

    // Handle redirection
    // useEffect(() => {
    //     const excludedPaths = ['/products', '/users/admin', '/profile'];  // List of paths to disregard
        
    //     if (noProducts && !startSurvey && !isRefreshing && !excludedPaths.includes(location.pathname)) {
    //         navigate('/products');
    //     }
    // }, [noProducts, startSurvey, isRefreshing, location.pathname, navigate]);

    if (!isSignedIn) {
        return <Navigate to="/login" />;
    }

    // if (!startSurvey && !isRefreshing) {
    //     return <StartSurvey />;
    // }

    return (
        <React.Fragment>
            {isSignedIn && <Header drawerWidth={drawerWidth} />}
            {/* {isSignedIn && <Sidebar drawerWidth={drawerWidth} />} */}
            <Box sx={{
                width: { sm: `calc(100% - ${isSignedIn ? drawerWidth : 0}px)` },
                ml: { sm: `${isSignedIn ? drawerWidth : 0}px` }, backgroundColor: 'background.white',
                mt: `${isSignedIn ? 70 : 0}px`, height: isSignedIn ? 'calc(100vh - 70px)': '100vh', overflowY: 'auto'
            }}>
                <Error />
                <Outlet />
            </Box>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        isSignedIn: state.auth.isSignedIn,
        startSurvey: state.profile.survey.startSurvey,
        isRefreshing: state.auth.isRefreshing,
        noProducts: Object.values(state.product.products).length === 0,
    };
};

export default connect(mapStateToProps, { fetchProducts })(PrivateRoute);
